import React from 'react';

interface TableProps {
    children: React.ReactNode;
    additionalClasses?: string;
}

const Table: React.FC<TableProps> = (props) => {
    const { children, additionalClasses } = props;
    return <table className={`table ${additionalClasses}`}>{children}</table>;
};

export default Table;
